export enum InstructionValidationType {
  WholeNumber = 'wholeNumber',
  WholeNumberMinMax = 'wholeNumberMinMax',
  OneDecimalMinMax = 'oneDecimalMinMax',
  TwoDecimalMinMax = 'twoDecimalMinMax',
  OneDecimal = 'oneDecimal',
  TwoDecimal = 'twoDecimal'
}
